{
    "productDashboard": {
        "common": {
            "last": "Utolsó",
            "for": "Összesen",
            "days": "nap",
            "day": "nap",
            "categories": "kategória",
            "open": "Nyitott",
            "inProgress": "Folyamatban",
            "inProgressShort": "Foly.",
            "resolved": "Megoldva",
            "clear": "Törlés",
            "selected": "kiválasztva",
            "clearAllFilters": "Összes szűrő törlése"
        },
        "shell": {
            "dataUpdated": "Adatok frissítve",
            "latestTurn": "legutóbbi kör",
            "records": "rekord",
            "ofData": "adat",
            "syncing": "Szinkronizálás…",
            "refresh": "↻ Adatok frissítése",
            "dataRefreshed": "Az adatok frissítve.",
            "syncFailed": "Nem sikerült elindítani a szinkronizálást.",
            "syncCompletedWithErrors": "A szinkronizálás hibákkal fejeződött be:",
            "timeRangeAria": "Időtartomány",
            "overview": "Áttekintés",
            "myhelpData": "a MyHelp adataiból",
            "rangeLabel": "Tartomány",
            "rangeAria": "Egyéni időtartomány",
            "rangeFrom": "Ettől",
            "rangeTo": "Eddig",
            "rangeApplyAria": "Időtartomány alkalmazása",
            "rangeClearAria": "Időtartomány törlése",
            "rangeSelectBoth": "Válassz kezdő és záró dátumot is.",
            "rangeInvalidOrder": "A kezdő dátumnak a záró dátum előtt kell lennie.",
            "rangeTooWide": "Válassz legfeljebb ekkora tartományt:",
            "dateRangeCaption": "Időtartomány"
        },
        "overview": {
            "greetingMorning": "Jó reggelt",
            "greetingAfternoon": "Szép napot",
            "greetingEvening": "Szép estét",
            "greetingNight": "Jó éjt",
            "subtitle": "Íme, mi történik ma a termékeiddel.",
            "tabOverview": "Áttekintés",
            "tabActionsForYou": "Teendők neked",
            "actionsTitle": "Teendők neked",
            "actionsMeta": "Ajánlott következő lépések a terméktulajdonosi csapatodnak",
            "kpiTotalQueries": "ÖSSZES LEKÉRDEZÉS",
            "kpiIncidentsRaised": "LÉTREHOZOTT INCIDENSEK (Szeptember 10-től)",
            "kpiUpcoming": "KÖZELGŐ FUNKCIÓ",
            "kpiCallback": "VISSZAHÍVÁSI KÉRÉSEK (Szeptember 10-től)",
            "kpiLiveChat": "ÉLŐ CHATES KÉRÉSEK (Szeptember 10-től)",
            "viewBreakdown": "Részletek →",
            "viewAllIncidents": "Összes incidens →",
            "upcomingTitle": "Hamarosan érkezik egy új funkció",
            "upcomingSub": "Hamarosan több termékinfó lesz elérhető.",
            "topCategories": "Leggyakoribb lekérdezési kategóriák",
            "viewAll": "Mutasd mindet →",
            "tipQueries": "Lekérdezések",
            "uniqueUsersTitle": "Egyedi felhasználók",
            "detailedView": "Részletes nézet",
            "usersPerDay": "Egyedi felhasználók naponta",
            "usersPerWeek": "Egyedi felhasználók hetente",
            "usersPerMonth": "Egyedi felhasználók havonta",
            "uniqueUsersTrendTooltipLead": "Összehasonlítás:",
            "uniqueUsersTrendTooltipConnector": "és",
            "kpiTooltips": {
                "totalQueries": "Az összes termékhez beérkezett lekérdezések száma a kiválasztott időszakban.",
                "incidentsRaised": "A chatbotos beszélgetésekből létrehozott incidensek, állapot szerint bontva.",
                "upcoming": "Készül egy új irányítópult-funkció — nézz vissza hamarosan.",
                "callback": "Felhasználók által küldött visszahívási kérések, nyelv szerint bontva.",
                "liveChat": "Felhasználók által küldött élő chates kérések, nyelv szerint bontva.",
                "feedbackCoverage": "Az összes lekérdezésnek az a része, amihez jött felhasználói visszajelzés (👍 vagy 👎)."
            }
        },
        "totalQueries": {
            "title": "Összes lekérdezés elemzése",
            "queries": "lekérdezés",
            "vsPrior": "az előző időszakhoz képest",
            "chartTitle": "Lekérdezések kategóriánként",
            "breakdownTitle": "Kategóriák részletezése",
            "thCategory": "KATEGÓRIA",
            "thQueries": "LEKÉRDEZÉSEK",
            "thShare": "ARÁNY",
            "thDistribution": "ELOSZLÁS",
            "tipQueries": "Lekérdezések",
            "tipShare": "Arány %",
            "searchPlaceholder": "Keresés",
            "matchesSuffix": "találat",
            "matchSuffix": "találat"
        },
        "incidents": {
            "title": "Incidenselemzés",
            "incidents": "incidens",
            "thId": "AZONOSÍTÓ",
            "thIssue": "LEKÉRDEZÉS / PROBLÉMA",
            "thCategory": "KATEGÓRIA",
            "thProduct": "TERMÉK",
            "thCompany": "VÁLLALAT",
            "thSeverity": "SÚLYOSSÁG",
            "thStatus": "ÁLLAPOT",
            "empty": "Ebben az időszakban nem volt MyHelp-incidens.",
            "severityHigh": "Magas",
            "severityMedium": "Közepes",
            "severityLow": "Alacsony",
            "incident": "incidens",
            "breakdownTitle": "Kategóriák részletezése",
            "thIncidents": "INCIDENSEK",
            "thShare": "ARÁNY",
            "thDistribution": "ELOSZLÁS",
            "searchPlaceholder": "Keresés",
            "matchesSuffix": "találat",
            "matchSuffix": "találat"
        },
        "incidentCategory": {
            "titlePrefix": "Incidensek itt:",
            "loadError": "Nem sikerült betölteni az incidenseket.",
            "incident": "incidens",
            "incidents": "incidens",
            "closeAria": "Bezárás",
            "thDate": "DÁTUM",
            "empty": "Ehhez a kategóriához nem található incidens.",
            "loading": "Betöltés…",
            "loadMorePrefix": "Továbbiak betöltése (most megjelenítve:",
            "of": "/"
        },
        "userSentiment": {
            "title": "Felhasználói visszajelzések áttekintése",
            "summaryLikes": "kedvelés",
            "summaryDislikes": "nem kedvelés",
            "last": "Utolsó",
            "days": "nap",
            "likes": "Kedvelések",
            "dislikes": "Nem kedvelések",
            "chartTitle": "Kedvelések és nem kedvelések kategóriánként",
            "detailTitle": "Visszajelzések kategóriánként, részletesen",
            "positive": "Pozitív",
            "thingsWell": "Ami jól működött",
            "thingsAttention": "Ami figyelmet igényel",
            "askAiHint": "Kérdezd meg az AI asszisztenst erről (új lapon nyílik meg)",
            "searchPlaceholder": "Keresés",
            "matchesSuffix": "találat",
            "matchSuffix": "találat"
        },
        "products": {
            "title": "Termékkategóriák",
            "products": "termék",
            "queryVolume": "Lekérdezések száma",
            "incidents": "Incidensek",
            "sentiment": "Felhasználói vélemény",
            "healthScore": "Állapotmutató"
        },
        "companyFilter": {
            "allCompanies": "Összes vállalat",
            "allCompaniesShort": "Összes vállalat",
            "selectedSuffix": "vállalat kiválasztva",
            "filterAria": "Szűrés vállalat szerint",
            "searchPlaceholder": "Vállalatok keresése…",
            "noMatchPrefix": "Nincs ilyen vállalat"
        },
        "clusterFilter": {
            "allClusters": "Összes klaszter",
            "allClustersShort": "Összes klaszter",
            "selectedSuffix": "klaszter kiválasztva",
            "filterAria": "Szűrés klaszter szerint",
            "searchPlaceholder": "Klaszterek keresése…",
            "noMatchPrefix": "Nincs ilyen klaszter"
        },
        "categoryFilter": {
            "allCategories": "Összes kategória",
            "selectedSuffix": "kategória kiválasztva",
            "filterAria": "Szűrés kategória szerint",
            "searchPlaceholder": "Kategóriák keresése…",
            "allCategoriesShort": "Összes kategória",
            "selectedShort": "kiválasztva",
            "clear": "Törlés",
            "noMatchPrefix": "Nincs ilyen kategória"
        },
        "categoryQueries": {
            "like": "Tetszik",
            "dislike": "Nem tetszik",
            "titlePrefix": "Lekérdezések ebben:",
            "loadError": "Nem sikerült betölteni a lekérdezéseket.",
            "query": "lekérdezés",
            "queries": "lekérdezés",
            "preparing": "Előkészítés…",
            "downloadExcel": "⬇ Excel letöltése",
            "closeAria": "Bezárás",
            "thQuery": "LEKÉRDEZÉS",
            "thSentiment": "VÉLEMÉNY",
            "thDate": "DÁTUM",
            "thSource": "FORRÁS",
            "thLanguage": "NYELV",
            "thCompany": "VÁLLALAT",
            "colQuery": "Lekérdezés",
            "colSentiment": "Vélemény",
            "colDate": "Dátum",
            "colSource": "Forrás",
            "colLanguage": "Nyelv",
            "colCompany": "Vállalat",
            "empty": "Ehhez a kategóriához nincs lekérdezés.",
            "loading": "Betöltés…",
            "loadMorePrefix": "Továbbiak betöltése (most megjelenítve:",
            "of": "/",
            "sortSentimentHint": "Kattintson a vélemény szerinti rendezéshez",
            "sortDateHint": "Kattintson a dátum szerinti rendezéshez"
        },
        "feedbackPie": {
            "likes": "Kedvelések",
            "dislikes": "Nem kedvelések",
            "noFeedback": "Nincs visszajelzés",
            "coverage": "VISSZAJELZÉSI LEFEDETTSÉG",
            "meta": "az összes lekérdezésből",
            "feedback": "visszajelzés",
            "noData": "Nincs adat",
            "viewFeedback": "Felhasználói visszajelzések →"
        },
        "requestCard": {
            "empty": "Ebben az időszakban nem jött kérés.",
            "breakdown": "Részletek →"
        },
        "requestBreakdown": {
            "titleCallback": "Visszahívási kérések — nyelvi bontás",
            "titleLiveChat": "Élő chates kérések — nyelvi bontás",
            "breakdownTitle": "Nyelvi bontás",
            "thLanguage": "NYELV",
            "thCount": "SZÁM",
            "thShare": "ARÁNY",
            "thDistribution": "ELOSZLÁS",
            "language": "nyelv",
            "languages": "nyelvek",
            "request": "kérés",
            "requests": "kérések",
            "empty": "Ebben az időszakban nem jött kérés."
        },
        "tabError": {
            "title": "Nem sikerült betölteni az irányítópult adatait",
            "message": "Az adatszolgáltatás nem válaszolt. Kérlek, próbáld újra. Mivel most nincs adat, az itt látható értékek egyike sem becslés."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Tudásbázis-cikkek létrehozása/frissítése",
                "hint": "Tartsd pontosan és naprakészen a termékeid tartalmát",
                "childTitle": "Tudásbázis létrehozása és frissítése",
                "childHint": "Így hozd létre és frissítsd a tudásbázist."
            },
            "scripts": {
                "title": "Szkriptek készítése és telepítése Nexthink Remote Actions-szel",
                "hint": "Automatizáld a hibaelhárítást: engedélyezd a távoli műveletet a felhasználó eszközén",
                "childTitle": "Link a Nexthink megrendeléséhez",
                "childHint": "Távoli műveletek kezelése"
            }
        }
    }
}
